module.exports = __webpack_public_path__ + "graphics/08.ckh.b99641f8e50d0bcf7584667b85827ef3.png";